import React from "react";
import "./PagesCss/ProcessoSeletivo.css";

function ProcessoSeletivo() {
  return (
    <React.StrictMode>
      <section id="seletiveProcess" className="flex-page-container">
        <section id="carreira-section">
          <h1 className="carreira-title">SEJA UM DE NÓS</h1>
          <p className="carreira-paragraph">
            Na Custodio Quessada Lima valorizamos excelência: no currículo, na
            atitude e na entrega.
          </p>
          <p className="carreira-paragraph">
            Temos oportunidades em diversas áreas: jurídico, administrativo,
            financeiro, atendimento ao cliente, novos negócios, inovação, e
            muito mais.
          </p>
          <p className="carreira-paragraph">
            Se você é um profissional proativo e quer fazer parte de um time de
            alta performance que joga pra ganhar, aprende rápido e entrega
            resultado, então a Custodio Quessada Lima é o seu lugar.
          </p>
          <p className="carreira-paragraph">
            Clique no botão abaixo e candidate-se para uma das nossas vagas.
          </p>
          <div className="button-container">
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSdMQLkc0W06x9uC9kJeEiv4CWH6yVGJ-DBFk_eMHfGgWALM0Q/viewform"
              className="trabalhe-custom1-btn"
            >
              Faça Parte
            </a>
          </div>
        </section>
      </section>
    </React.StrictMode>
  );
}

export default ProcessoSeletivo;
